<template>
  <!-- 调拨单列表 -->
  <div class="form">
    <div class="container">
      <!-- 搜索表单 -->
      <el-form :model="searchForm" label-width="120px">
        <el-row>
          <el-col span="6">
            <el-form-item label="调拨单号：" prop="outboundNo">
              <el-input
                placeholder="调拨单号"
                maxlength="30"
                show-word-limit
                clearable
                v-model="searchForm.allotNo"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item label="单据日期：" prop="outBoundRq">
              <el-date-picker
                style="width: 100%"
                v-model="searchForm.outBoundRq"
                value-format="yyyy-MM-dd"
                format="yyyy-MM-dd"
                type="date"
                placeholder="单据日期"
                size="small"
                clearable
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item label="单据状态：" prop="allotWorkStatus">
              <el-select
                style="width: 100%"
                v-model="searchForm.allotWorkStatus"
                placeholder="单据状态"
                clearable
              >
                <el-option
                  v-for="(item, index) in statusList"
                  :key="index"
                  :label="item.dictValue"
                  :value="item.dictKey"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="6">
            <el-form-item label="调入仓库：" prop="destWarehouseId">
              <el-select
                style="width: 100%"
                v-model="searchForm.destWarehouseId"
                placeholder="调入仓库"
                clearable
              >
                <el-option
                  v-for="(item, index) in warehouseList"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="24">
            <el-form-item>
              <div style="float: right;">
                <el-button type="primary" icon="el-icon-search" size="small" @click="searchChange"
                  >搜索</el-button
                >
                <el-button plain icon="el-icon-delete" size="small" @click="searchReset"
                  >清空</el-button
                >
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <avue-crud
        :option="tableOption"
        :data="tableData"
        :page.sync="tablePage"
        @on-load="loadData"
        @row-click="rowClick"
      >
        <template slot="radio" slot-scope="{ row }">
          <el-radio v-model="selectRowIndex" :label="row.$index">{{ '' }}</el-radio>
        </template>
      </avue-crud>
    </div>
    <!-- 按钮占位区域 -->
    <div class="placeholder"></div>
    <!-- 底部操作按钮 -->
    <div class="btn">
      <el-button type="primary" size="small" @click="doSave">确定</el-button>
      <el-button size="small" @click="doClose">取消</el-button>
    </div>
  </div>
</template>

<script>
import { getAllWarehouseListApi, getDictApi } from '@/api/warehouse/index';
import { getTransferOrderListApi } from '@/api/warehouse/out';

export default {
  name: 'TransferOrderList',
  props: {
    // 项目id
    projectId: {
      type: String,
      default: '',
    },
    // 仓库id
    warehouseId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      // 搜索表单
      searchForm: {},
      // 仓库列表
      warehouseList: [],
      // 状态列表
      statusList: [],
      // 选中的行在当前页的序号
      selectRowIndex: -1,
      // 表格数据
      tableData: [],
      // 选中的项
      selectedList: [],
      // 表格分页信息
      tablePage: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      // 表格选项
      tableOption: {
        height: 'auto',
        calcHeight: 'auto',
        border: true,
        refreshBtn: false,
        columnBtn: false,
        addBtn: false,
        menu: false,
        dialogClickModal: false,
        column: [
          {
            label: '选择',
            prop: 'radio',
            width: 50,
            slot: true,
          },
          {
            label: '调拨单',
            prop: 'allotNo',
          },
          {
            label: '物料摘要',
            prop: 'materialSummary',
          },
          {
            label: '调出仓库',
            prop: 'originWarehouseId',
            dicData: [],
            props: {
              label: 'name',
              value: 'id',
            },
          },
          {
            label: '调入仓库',
            prop: 'destWarehouseId',
            dicData: [],
            props: {
              label: 'name',
              value: 'id',
            },
          },
          {
            label: '单据时间',
            prop: 'applyTime',
          },
          {
            label: '状态',
            prop: 'allotWorkStatus',
            props: {
              label: 'dictValue',
              value: 'dictKey',
            },
            dataType: 'string',
          },
        ],
      },
    };
  },
  async created() {
    // tips 保证单据状态先获取到再去请求列表数据，否则列表里的状态列可能会显示错误
    // 获取单据状态
    await getDictApi({
      code: 'warehouse_allot_work_status',
    }).then(({ data }) => {
      let newArr = [];
      // 产品要求当前列表只保留部分状态
      let labelArr = ['待出库', '部分出库'];
      data.forEach((item) => {
        if (labelArr.includes(item.dictValue)) {
          newArr.push(item);
        }
      });
      this.statusList = newArr;
      this.findObject(this.tableOption.column, 'allotWorkStatus').dicData = this.statusList;
    });
    // 获取仓库列表
    getAllWarehouseListApi({
      projectId: this.projectId,
    }).then(({ data }) => {
      this.warehouseList = data || [];
      this.findObject(this.tableOption.column, 'originWarehouseId').dicData = this.warehouseList;
      this.findObject(this.tableOption.column, 'destWarehouseId').dicData = this.warehouseList;
    });
  },
  methods: {
    /* 加载列表数据 */
    loadData(page) {
      page = page || this.tablePage;
      getTransferOrderListApi(
        Object.assign(
          {
            current: page.currentPage,
            size: page.pageSize,
            projectId: this.projectId,
            originWarehouseId: this.warehouseId,
          },
          this.searchForm
        )
      ).then(({ data }) => {
        this.tablePage.total = data.total;
        this.tableData = data.records;
        if (this.selectRowIndex >= this.tablePage.total) {
          this.selectRowIndex = -1;
        }
      });
    },
    /* 重置搜索 */
    searchReset() {
      this.selectRowIndex = -1;
      this.searchForm = {};
      this.tablePage.currentPage = 1;
      this.loadData();
    },
    /* 条件搜索 */
    searchChange() {
      this.selectRowIndex = -1;
      this.tablePage.currentPage = 1;
      this.loadData();
    },
    /* 行点击 */
    rowClick(row) {
      this.selectRowIndex = row.$index;
    },
    doSave() {
      if (this.selectRowIndex < 0) {
        this.$message.warning('请先选择数据');
        return;
      }
      this.$emit('update', this.tableData[this.selectRowIndex]);
      this.doClose();
    },
    doClose() {
      this.$emit('close');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../dialog-form.scss';

/* 去掉表格上方的空白区域 */
::v-deep .avue-crud__menu {
  display: none !important;
}
</style>
